import { render, staticRenderFns } from "./OrderHold.vue?vue&type=template&id=24ea416a&"
import script from "./OrderHold.vue?vue&type=script&lang=js&"
export * from "./OrderHold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports